























































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { EResidentStatus } from '@zunta/configurations'

import Vue2Filters from 'vue2-filters'
import Api from '@/api'
import { User } from '@/classes/User'
import ResidentStatementBlock from './components/StatementsBlock.vue'
import PaymentHistory from './components/PaymentHistory.vue'
import ResidentCreditCardsBlock from './components/CreditCardsBlock.vue'
import Card from '@/components/Card.vue'

@Component({
  mixins: [ Vue2Filters.mixin ],
  components: {
    Card,
    Icon,
    ResidentStatementBlock,
    PaymentHistory,
    ResidentCreditCardsBlock
  }
})
export default class ManagementResidentPage extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  EResidentStatus: any = EResidentStatus;
  user: User = Api.getUser() as User;

  get residentID () {
    return this.user.getResidents()[0]
  }

  get resident () {
    return this.$store.state.resident.selectedResident
  }

  async mounted () {
    this.$locationManager.rememberLocation(this.$route.fullPath)
    await Promise.all([
      this.residentModuleInstance.fetchResidentById(this.residentID)
    ])
  }

  getResidentStatusLabel (status: EResidentStatus) {
    const STATUSES_MAP: any = {
      [EResidentStatus.ACTIVE]: 'Current',
      [EResidentStatus.INACTIVE]: 'Discharged'
    }
    return STATUSES_MAP[status]
  }

  goTo (options: any): void {
    this.$locationManager.rememberAndGoTo(options).catch((e: any) => e)
  }
}
